export const WsEvents = Object.freeze({
  PING: "ping",
  NOTIFICATION: "notification",
  CONNECTION_ESTABLISHED: "connectionEstablished",
});
